import classNames from "classnames/dedupe";
import React, { FC } from "react";

import { FormLabel } from "../../../Atoms/FormLabel";
import { Input } from "../../Input";
import { TThemeVariant, useTheme } from "../../../Utility/ThemeProvider";
import { TCheckboxProps, TColorVariants } from "../Checkbox/Checkbox.interface";
import { useCheckbox } from "../useCheckbox";

export interface ITileCheckboxProps extends TCheckboxProps {
  /**
   * Set main text of a tile (rendered bold in center)
   */
  title?: string;
  /**
   * If set a color example will be rendered in center of a tile.
   * Tile itself becomes bigger
   *
   * @type {TColorVariants}
   */
  color?: TColorVariants;
  /**
   * Number of items that will be filtered (rendered in small font in corner of a tile)
   */
  count?: number;

  /**
   * Set if value is not available
   */
  unavailable?: boolean;
}

export const TileCheckbox: FC<ITileCheckboxProps> = ({
  title,
  count = null,
  variant,
  checked = false,
  color = "",
  unavailable,
  onChange,
  ...inputProps
}) => {
  const [isChecked, handleChange] = useCheckbox(checked, onChange);

  const theme: TThemeVariant = useTheme(variant);

  const rootClasses = classNames("checkbox-tile", {
    "checkbox-tile--light": theme === "light",
    "checkbox-tile--color": color,
    unavailable,
  });

  const colorTile = () => {
    return (
      color && (
        <span
          className={`checkbox-tile__color checkbox-tile__color--${color}`}
        />
      )
    );
  };

  return (
    <FormLabel classes={{ root: rootClasses }}>
      <span className="checkbox-tile__wrap">
        <Input
          type="checkbox"
          checked={unavailable ? false : isChecked}
          disabled={unavailable}
          onChange={handleChange}
          className="checkbox-tile__input"
          data-testid="checkbox-tile-input"
          {...inputProps}
        />
        <span className="checkbox-tile__bg" />
        {colorTile()}
        <span className="checkbox-tile__title">{title}</span>
        <span className="checkbox-tile__corner">{count}</span>
      </span>
    </FormLabel>
  );
};
